<button [appUITooltip]="true"
  [placement]="'bottom'"
  [trigger]="'hover'"
  ttitle="Download selected documents"
  i18n-ttitle="@@app.download_selected_documents"
  class="btn btn-primary py-1 px-2 rounded-border-btn bg-light-blue text-uppercase d-flex align-items-center"
  [ngClass]="{'pointer-events-none opacity-6': (numberOfSelectedDocuments < 1 || loading)}"
  (click)="downloadDocuments()">
  @if (loading) {
    <div class="spinner-border spinner-border-sm mr-2"></div>
  } @else {
    <img alt="" src="/assets/images/download_new_icon.svg" class="mr-1">
  }
  <div class="font-weight-bolder font-size-xs d-inline-block py-1 align-text-top">
    <ng-container i18n="@@app.download">Download</ng-container>
  </div>
</button>
